'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const P = require('./protocol.js');

const {
  createLimitedRenderer
} = require('./limited-packages.js');

const {
  createIntro
} = require('./intro-video.js');

const {
  createOpeningNavigation
} = require('./opening-navigation.js');

const {
  bindMobileLayout
} = require('./mobile-layout.js');

const {
  createPackSession
} = require('./pack-session.js');

const {
  createQuoteIntents
} = require('./quote-intents.js');

const {
  navigateOriginalPayment
} = require('./payment-bridge.js');

const SLOGAN = '卡的最高價值為4600人民幣';
const deliveryLabel = {
  NOT_STARTED: '尚未領取',
  PENDING: '獎勵處理中',
  PARTIAL: '部分獎勵已送達，其餘處理中',
  GRANTED: '獎勵已送達'
}; // The SDK supplies its existing React instance. No second React/runtime is bundled.

function createComponents(React) {
  const h = React.createElement;
  const renderLimitedPackages = createLimitedRenderer(React);
  const OpCardIntro = createIntro(React);
  const OpeningNavigation = createOpeningNavigation(React);

  function button(label, onClick, disabled, props = {}) {
    return h('button', {
      type: 'button',
      onClick,
      disabled,
      ...props
    }, label);
  }

  function OpCardEntrances({
    enabled = false,
    onOpen,
    limitedAvailable = false
  }) {
    return h('nav', {
      className: 'opcards-entries',
      'aria-label': '典藏卡包'
    }, button(h(React.Fragment, null, h('strong', null, '常駐典藏卡包'), h('span', null, SLOGAN), h('small', null, '2／3／5／10 包')), () => onOpen('permanent'), !enabled || typeof onOpen !== 'function', {
      className: 'opcards-entry opcards-entry-red'
    }), button(h(React.Fragment, null, h('strong', null, '限時典藏合輯'), h('span', null, SLOGAN), h('small', null, 'Normal／VIP 合併活動 · 逐步購買')), () => onOpen('limited'), !enabled || !limitedAvailable || typeof onOpen !== 'function', {
      className: 'opcards-entry'
    }));
  }

  class OpCardHub extends React.Component {
    constructor(props) {
      super(props);

      _defineProperty(this, "returned", e => {
        if (e.persisted) this.refresh();
      });

      _defineProperty(this, "refresh", async () => {
        const runtime = this.props.runtime,
              run = ++this.generation;

        if (!(runtime === null || runtime === void 0 ? void 0 : runtime.api)) {
          this.setState({
            error: '卡包服務尚未接通。',
            busy: false
          });
          return;
        }

        this.setState({
          busy: true,
          error: ''
        });

        try {
          const [catalogue, packs, collection, activity] = await Promise.all([runtime.api.catalogue(), runtime.api.packs(), runtime.api.collection(), runtime.refreshActivity ? runtime.refreshActivity() : Promise.resolve(null)]);

          if (this.alive && run === this.generation) {
            for (const [key, intent] of this.quoteKeys) {
              if (intent.quoteId && packs.items.some(p => p.quoteId === intent.quoteId)) this.quoteKeys.delete(key);
            }

            const confirmed = this.state.quote && packs.items.some(p => p.quoteId === this.state.quote.quoteId);
            this.setState({
              catalogue,
              inventory: packs.items,
              cursor: packs.cursor,
              collection,
              activity,
              busy: false,
              ...(confirmed ? {
                quote: null,
                selected: null
              } : {})
            });
          }
        } catch (e) {
          if (this.alive && run === this.generation) this.setState({
            busy: false,
            error: e.message || '未能讀取卡包資料。'
          });
        }
      });

      _defineProperty(this, "tab", tab => {
        ++this.generation;
        this.setState({
          tab,
          page: 'packages',
          selected: null,
          quote: null,
          error: '',
          busy: false
        });
      });

      _defineProperty(this, "choose", async sku => {
        const r = this.props.runtime,
              c = this.state.catalogue;
        if (r.readOnly || this.state.busy || !(c === null || c === void 0 ? void 0 : c.purchasingEnabled)) return;
        const run = ++this.generation,
              intents = this.quoteKeys;
        this.setState({
          selected: sku.skuId,
          quote: null,
          busy: true,
          error: ''
        });

        try {
          var _intent;

          let activity = this.state.activity;

          if (sku.kind === 'limited') {
            var _activity;

            activity = r.refreshActivity ? await r.refreshActivity() : null;
            P.check(((_activity = activity) === null || _activity === void 0 ? void 0 : _activity.activityId) && activity.nextStep === sku.step && !activity.completed, 'ACTIVITY_STEP_NOT_AVAILABLE');
            if (this.alive && run === this.generation) this.setState({
              activity
            });
          }

          const key = sku.skuId + ':' + (sku.kind === 'limited' ? activity.activityId : '');
          let quote = null,
              intent = intents.get(key);

          if ((_intent = intent) === null || _intent === void 0 ? void 0 : _intent.quoteId) {
            const prior = await r.api.getQuote(intent.quoteId);
            P.check(prior.skuId === sku.skuId, 'SAVED_QUOTE_SKU_MISMATCH');
            if (prior.status === 'PAYABLE') quote = prior;else {
              intents.delete(key);
              intent = null;
            }
          } // A limited pending quote may have originated before this local browser session.


          if (!quote && sku.kind === 'limited' && activity.pendingQuoteId) {
            const prior = await r.api.getQuote(activity.pendingQuoteId);
            P.check(prior.skuId === sku.skuId && prior.activityId === activity.activityId && prior.status === 'PAYABLE', 'LIMITED_QUOTE_REQUIRES_REFRESH');
            quote = prior;
          }

          if (!quote) {
            if (!intents.has(key)) intents.set(key, {
              requestId: r.makeRequestId(),
              quoteId: null
            });
            const input = {
              skuId: sku.skuId,
              idempotencyKey: intents.get(key).requestId,
              ...(sku.kind === 'limited' ? {
                activityId: activity.activityId
              } : {})
            };
            quote = await r.api.quote(input);
            intents.set(key, { ...intents.get(key),
              quoteId: quote.quoteId
            });

            if (quote.status !== 'PAYABLE') {
              intents.delete(key);
              P.check(false, 'QUOTE_FINISHED_SELECT_AGAIN');
            }
          }

          const bound = quote.catalogueHash === c.catalogueHash ? c : await r.api.catalogue(quote.catalogueHash);
          const original = bound.packages.find(p => p.skuId === quote.skuId);
          P.check(original && quote.paidPacks === original.paidPacks && quote.giftPacks === original.giftPacks, 'QUOTE_CATALOGUE_MISMATCH');
          if (this.alive && run === this.generation) this.setState({
            quote,
            busy: false
          });
        } catch (e) {
          if (this.alive && run === this.generation) this.setState({
            busy: false,
            error: e.message || '未能確認報價。請重試原選項。'
          });
        }
      });

      _defineProperty(this, "checkout", async () => {
        if (this.props.runtime.readOnly || this.state.busy || !this.state.quote) return;
        this.setState({
          busy: true,
          error: ''
        });

        try {
          await navigateOriginalPayment(this.state.quote, this.props.runtime.payment);
        } catch (e) {
          if (this.alive) this.setState({
            error: e.message || '原付款頁尚未接通。'
          });
        } finally {
          if (this.alive) this.setState({
            busy: false
          });
        }
      });

      _defineProperty(this, "more", async () => {
        if (this.state.busy || !this.state.cursor) return;
        const run = ++this.generation;
        this.setState({
          busy: true
        });

        try {
          const result = await this.props.runtime.api.packs(this.state.cursor);

          if (this.alive && run === this.generation) {
            const ids = new Set(this.state.inventory.map(p => p.packId));
            this.setState({
              inventory: [...this.state.inventory, ...result.items.filter(p => !ids.has(p.packId))],
              cursor: result.cursor,
              busy: false
            });
          }
        } catch (e) {
          if (this.alive && run === this.generation) this.setState({
            error: e.message,
            busy: false
          });
        }
      });

      this.state = {
        catalogue: null,
        inventory: [],
        cursor: null,
        collection: null,
        page: ['collection', 'inventory'].includes(props.page) ? props.page : 'packages',
        tab: props.tab === 'limited' ? 'limited' : 'permanent',
        selected: null,
        quote: null,
        activity: null,
        busy: false,
        error: '',
        collectionPage: 0,
        inspect: null
      };
      this.generation = 0;
      this.quoteKeys = createQuoteIntents(props.runtime);
    }

    componentDidMount() {
      this.alive = true;
      this.refresh();
      if (typeof window !== 'undefined') window.addEventListener('pageshow', this.returned);
    }

    componentDidUpdate(prev) {
      if (prev.runtime !== this.props.runtime) {
        ++this.generation;
        this.quoteKeys = createQuoteIntents(this.props.runtime);
        this.setState({
          catalogue: null,
          inventory: [],
          collection: null,
          quote: null,
          inspect: null
        }, () => this.refresh());
      }
    }

    componentWillUnmount() {
      this.alive = false;
      ++this.generation;
      if (typeof window !== 'undefined') window.removeEventListener('pageshow', this.returned);
    }

    packageScreen() {
      var _s$catalogue, _s$catalogue3;

      const s = this.state,
            r = this.props.runtime;
      if (s.tab === 'limited' && s.catalogue) return renderLimitedPackages({
        items: s.catalogue.packages,
        activity: s.activity,
        readOnly: r.readOnly,
        busy: s.busy,
        quote: s.quote,
        slogan: SLOGAN,
        onChoose: this.choose,
        onCheckout: this.checkout,
        onTab: this.tab
      });
      const items = (((_s$catalogue = s.catalogue) === null || _s$catalogue === void 0 ? void 0 : _s$catalogue.packages) || []).filter(p => p.kind === s.tab);
      return h(React.Fragment, null, h('section', {
        className: 'opcards-hero'
      }, h('small', null, s.tab === 'limited' ? '限時典藏合輯' : '常駐典藏卡包'), h('h1', null, SLOGAN), h('p', null, r.readOnly ? '卡包預覽 · 目前尚未開售或開放揭卡。' : '每包一張典藏卡。付款後保留卡包，完整揭開才領取卡內獎勵。')), h('div', {
        className: 'opcards-tabs'
      }, button('常駐卡包', () => this.tab('permanent'), s.busy, {
        'aria-pressed': s.tab === 'permanent'
      }), button('限時合輯', () => this.tab('limited'), s.busy, {
        'aria-pressed': s.tab === 'limited'
      })), s.tab === 'limited' && h('p', {
        className: 'opcards-progress'
      }, s.activity ? s.activity.completed ? '本活動已完成 · 每位玩家限一輪' : "\u76EE\u524D\u7B2C ".concat(s.activity.nextStep, " \u6B65 \xB7 \u6BCF\u4F4D\u73A9\u5BB6\u6BCF\u6D3B\u52D5\u4E00\u8F2A") : '尚未發佈活動排程；目前只供查看。'), h('div', {
        className: 'opcards-package-grid'
      }, items.map(p => {
        var _s$quote, _s$catalogue2;

        const locked = p.kind === 'limited' && (!s.activity || s.activity.nextStep !== p.step);
        return button(h(React.Fragment, null, h('span', {
          className: 'opcards-foil',
          'aria-hidden': true
        }, 'OP'), h('strong', null, "".concat(p.paidPacks, " \u5305")), p.giftPacks > 0 && h('b', {
          className: 'opcards-bonus'
        }, "\u53E6\u8D08 ".concat(p.giftPacks, " \u5305")), h('span', null, p.name), h('small', null, r.readOnly ? '尚未開售' : locked ? '尚未開放' : ((_s$quote = s.quote) === null || _s$quote === void 0 ? void 0 : _s$quote.skuId) === p.skuId ? P.money(s.quote.amountMinor, s.quote.currency) : '選擇後確認價格')), () => this.choose(p), r.readOnly || s.busy || locked || !((_s$catalogue2 = s.catalogue) === null || _s$catalogue2 === void 0 ? void 0 : _s$catalogue2.purchasingEnabled), {
          key: p.skuId,
          className: 'opcards-package',
          'aria-pressed': s.selected === p.skuId
        });
      })), !((_s$catalogue3 = s.catalogue) === null || _s$catalogue3 === void 0 ? void 0 : _s$catalogue3.purchasingEnabled) && h('p', {
        role: 'status'
      }, '卡包尚未開放購買。'), s.quote && h('aside', {
        className: 'opcards-quote'
      }, h('strong', null, P.money(s.quote.amountMinor, s.quote.currency)), h('p', null, "".concat(s.quote.paidPacks, " \u5305").concat(s.quote.giftPacks ? '＋贈 ' + s.quote.giftPacks + ' 包' : '', "\uFF1B\u4E0D\u53E6\u9644\u5373\u6642 OP \u5E63\u3002")), button('選擇付款方式', this.checkout, s.busy, {
        className: 'opcards-primary'
      }), h('small', null, '沿用原 SDK 的支付寶／微信／Visa 付款選擇頁。')));
    }

    inventoryScreen() {
      const s = this.state;
      return h('section', null, h('h1', null, '我的卡包'), h('p', null, '只顯示後端已確認的卡包。付款返回本頁不等於付款成功。'), s.inventory.length === 0 && h('p', null, this.props.runtime.readOnly ? '尚未持有卡包。' : '尚未查到卡包，可重新查詢付款結果。'), s.inventory.map(p => h('article', {
        key: p.packId,
        className: 'opcards-pack-row'
      }, h('span', {
        className: 'opcards-foil',
        'aria-hidden': true
      }, 'OP'), h('div', null, h('strong', null, p.status === 'OPENED' ? '已揭曉卡包' : '待開典藏卡包'), h('p', null, deliveryLabel[p.deliveryStatus])), button(p.status === 'OPENED' ? '查看同一卡片' : '慢慢揭開', () => this.props.onOpenPack(p.packId), s.busy || typeof this.props.onOpenPack !== 'function'))), s.cursor && button('載入更多', this.more, s.busy));
    }

    collectionScreen() {
      var _s$collection, _s$catalogue4;

      const s = this.state,
            owned = new Map((((_s$collection = s.collection) === null || _s$collection === void 0 ? void 0 : _s$collection.cards) || []).map(c => [c.cardId, c])),
            cards = ((_s$catalogue4 = s.catalogue) === null || _s$catalogue4 === void 0 ? void 0 : _s$catalogue4.cards) || [],
            pages = Math.max(1, Math.ceil(cards.length / 12));
      return h('section', null, h('h1', null, '典藏圖鑑'), h('p', null, '同一卡片的不同造型合併收藏，獎勵相同。'), h('div', {
        className: 'opcards-collection'
      }, cards.slice(s.collectionPage * 12, s.collectionPage * 12 + 12).map(c => {
        const entry = owned.get(c.cardId),
              has = !!entry && entry.count !== '0',
              style = this.props.runtime.artwork(c.cardId, c.styles[0]);
        return h('article', {
          key: c.cardId
        }, button(h(React.Fragment, null, style && h('img', {
          src: style.thumb,
          loading: 'lazy',
          decoding: 'async',
          alt: has ? c.name : '尚未擁有的卡片'
        }), h('span', null, c.cardId)), () => this.setState({
          inspect: {
            card: c,
            owned: entry
          }
        }), !has, {
          className: 'opcards-collection-card' + (has ? '' : ' unowned'),
          'aria-label': has ? '放大 ' + c.cardId : c.cardId + ' 尚未擁有'
        }), h('strong', null, c.name), h('small', null, "".concat(c.styles.length, " \u7A2E\u9020\u578B")), h('p', null, c.rewardText));
      })), h('div', {
        className: 'opcards-pagination'
      }, button('上一頁', () => this.setState({
        collectionPage: s.collectionPage - 1
      }), s.collectionPage === 0), h('span', null, "".concat(s.collectionPage + 1, " / ").concat(pages)), button('下一頁', () => this.setState({
        collectionPage: s.collectionPage + 1
      }), s.collectionPage + 1 >= pages)));
    }

    render() {
      const s = this.state;
      return h('main', {
        className: 'opcards-shell'
      }, h('header', null, button('返回', this.props.onBack, !this.props.onBack), h('strong', null, 'OP 典藏卡包'), button('重新查詢', this.refresh, s.busy)), h('nav', {
        className: 'opcards-nav'
      }, [['packages', '卡包'], ['inventory', '我的卡包'], ['collection', '圖鑑']].map(([page, label]) => button(label, () => this.setState({
        page,
        error: ''
      }), s.busy, {
        key: page,
        'aria-current': s.page === page ? 'page' : undefined
      }))), s.error && h('p', {
        role: 'alert',
        className: 'opcards-error'
      }, s.error), s.busy && h('p', {
        role: 'status'
      }, '正在確認…'), s.page === 'packages' ? h(React.Fragment, null, h(OpCardIntro, {
        scopeKey: this.props.runtime.scopeKey
      }), this.packageScreen()) : s.page === 'inventory' ? this.inventoryScreen() : this.collectionScreen(), s.inspect && h(OpCardOwnedView, {
        runtime: this.props.runtime,
        ...s.inspect,
        onClose: () => this.setState({
          inspect: null
        })
      }));
    }

  }

  class OpCardOwnedView extends React.Component {
    constructor(props) {
      super(props);
      this.styles = props.card.styles.filter(s => {
        var _props$owned, _props$owned$styles;

        return ((_props$owned = props.owned) === null || _props$owned === void 0 ? void 0 : (_props$owned$styles = _props$owned.styles) === null || _props$owned$styles === void 0 ? void 0 : _props$owned$styles[s]) && props.owned.styles[s] !== '0';
      });
      this.state = {
        styleId: this.styles[0],
        error: ''
      };
      this.paintGeneration = 0;
      this.disposed = false;
    }

    componentDidMount() {
      var _this$close;

      this.paint();
      this.previousFocus = document.activeElement;
      (_this$close = this.close) === null || _this$close === void 0 ? void 0 : _this$close.focus();
    }

    componentDidUpdate(prev, prevState) {
      if (prevState.styleId !== this.state.styleId) this.paint();
    }

    componentWillUnmount() {
      var _this$paintAbort, _this$view, _this$previousFocus, _this$previousFocus$f;

      this.disposed = true;
      ++this.paintGeneration;
      (_this$paintAbort = this.paintAbort) === null || _this$paintAbort === void 0 ? void 0 : _this$paintAbort.abort();
      (_this$view = this.view) === null || _this$view === void 0 ? void 0 : _this$view.dispose();
      (_this$previousFocus = this.previousFocus) === null || _this$previousFocus === void 0 ? void 0 : (_this$previousFocus$f = _this$previousFocus.focus) === null || _this$previousFocus$f === void 0 ? void 0 : _this$previousFocus$f.call(_this$previousFocus);
    }

    async paint() {
      var _this$paintAbort2, _this$view2;

      (_this$paintAbort2 = this.paintAbort) === null || _this$paintAbort2 === void 0 ? void 0 : _this$paintAbort2.abort();
      (_this$view2 = this.view) === null || _this$view2 === void 0 ? void 0 : _this$view2.dispose();
      this.paintAbort = new AbortController();
      const run = ++this.paintGeneration;

      try {
        const view = await this.props.runtime.visuals.mountOwned({
          canvas: this.canvas,
          card: this.props.card,
          style: this.props.runtime.artwork(this.props.card.cardId, this.state.styleId),
          signal: this.paintAbort.signal,
          isCurrent: () => !this.disposed && run === this.paintGeneration
        });

        if (this.disposed || run !== this.paintGeneration) {
          view.dispose();
          return;
        }

        this.view = view;
      } catch (e) {
        if (!this.disposed && run === this.paintGeneration) this.setState({
          error: e.message
        });
      }
    }

    render() {
      return h('div', {
        role: 'dialog',
        'aria-modal': true,
        'aria-label': '已擁有卡片',
        className: 'opcards-inspect',
        onKeyDown: e => {
          if (e.key === 'Escape') this.props.onClose();
        }
      }, button('關閉', this.props.onClose, false, {
        ref: e => this.close = e
      }), h('canvas', {
        ref: e => this.canvas = e,
        width: 612,
        height: 876,
        'aria-label': this.props.card.name
      }), h('select', {
        value: this.state.styleId,
        onChange: e => this.setState({
          styleId: e.target.value
        }),
        'aria-label': '已擁有造型'
      }, this.styles.map((id, i) => h('option', {
        key: id,
        value: id
      }, "\u9020\u578B ".concat(i + 1)))), h('p', null, this.props.card.rewardText), this.state.error && h('p', {
        role: 'alert'
      }, this.state.error));
    }

  }

  class OpCardOpening extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        snapshot: null,
        error: '',
        busy: true
      };
    }

    async componentDidMount() {
      this.alive = true;
      if (typeof window !== 'undefined' && this.root && this.stage && this.canvas) this.releaseLayout = bindMobileLayout(window, this.root, this.stage, this.canvas);
      const r = this.props.runtime;

      try {
        this.session = createPackSession({
          api: r.api,
          packId: this.props.packId,
          scopeKey: r.scopeKey,
          storage: r.storage,
          makeRequestId: r.makeRequestId,
          onChange: s => {
            if (this.alive) {
              var _this$surface;

              this.setState({
                snapshot: s,
                busy: s.busy,
                error: s.error
              });
              (_this$surface = this.surface) === null || _this$surface === void 0 ? void 0 : _this$surface.update(s);
            }
          }
        });
        await r.api.catalogue();
        if (!this.alive) return;
        this.surface = await r.visuals.mount({
          canvas: this.canvas,
          fxCanvas: this.fxCanvas,
          audioButton: this.audioButton,
          audioStatus: this.audioStatus,
          reduceControl: this.reduceControl,
          resolveOutcome: o => r.resolveOutcome(o),
          onBegin: () => this.session.beginReveal(),
          onComplete: () => this.session.open(),
          onError: e => this.alive && this.setState({
            error: e.message
          })
        });

        if (!this.alive) {
          this.surface.dispose();
          return;
        }

        this.setState({
          pointerFallback: this.surface.pointerSupported === false
        });
        await this.session.load();
      } catch (e) {
        if (this.alive) this.setState({
          error: e.message,
          busy: false
        });
      }
    }

    componentWillUnmount() {
      var _this$releaseLayout, _this$session, _this$surface2;

      this.alive = false;
      (_this$releaseLayout = this.releaseLayout) === null || _this$releaseLayout === void 0 ? void 0 : _this$releaseLayout.call(this);
      (_this$session = this.session) === null || _this$session === void 0 ? void 0 : _this$session.dispose();
      (_this$surface2 = this.surface) === null || _this$surface2 === void 0 ? void 0 : _this$surface2.dispose();
    }

    render() {
      var _this$state$snapshot, _this$state$snapshot2;

      const p = (_this$state$snapshot = this.state.snapshot) === null || _this$state$snapshot === void 0 ? void 0 : _this$state$snapshot.pack;
      return h('main', {
        className: 'opcards-opening',
        ref: e => this.root = e
      }, h('header', null, button('我的卡包', this.props.onBack, false), h('strong', null, 'OP 典藏卡'), button('♫ 開啟音樂與音效', undefined, false, {
        ref: e => this.audioButton = e,
        'data-audio-control': true,
        'aria-pressed': 'false'
      })), h('span', {
        className: 'opcards-audio-status',
        ref: e => this.audioStatus = e
      }), h('div', {
        className: 'opcards-opening-layout'
      }, h('section', {
        className: 'opcards-stage',
        ref: e => this.stage = e
      }, h('canvas', {
        ref: e => this.canvas = e,
        width: 960,
        height: 1220,
        tabIndex: 0,
        'aria-label': '按住任意位置向任何方向慢慢揭開；放手停住，反向蓋回。Enter 完整揭開。'
      })), h('section', {
        className: 'opcards-opening-controls'
      }, h('h1', null, (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? '你的典藏卡' : '慢慢揭開，屬於你的卡'), h('p', null, this.state.pointerFallback ? '此瀏覽器請使用下方按鈕揭開；原卡包不會改變。' : '上下左右・四角皆可'), (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' && h('div', {
        className: 'opcards-prize',
        role: 'status',
        'aria-live': 'polite'
      }, h('strong', null, '本卡獎勵'), h('p', null, this.props.runtime.describeReward(p.outcome)), h('span', null, deliveryLabel[p.deliveryStatus])), button((p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? '重播同一卡片效果' : '一次剝開', () => {
        var _this$surface3;

        return (_this$surface3 = this.surface) === null || _this$surface3 === void 0 ? void 0 : _this$surface3.openExplicit();
      }, this.state.busy || !p, {
        className: 'opcards-primary'
      }), (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? h(OpeningNavigation, {
        runtime: this.props.runtime,
        currentPackId: this.props.packId,
        onOpenPack: this.props.onOpenPack,
        onPackages: this.props.onPackages
      }) : button('重新查詢同一卡包', () => {
        var _this$session2;

        return (_this$session2 = this.session) === null || _this$session2 === void 0 ? void 0 : _this$session2.reconcile();
      }, this.state.busy), this.state.error && button('重新載入原定卡面', () => {
        var _this$surface4;

        this.setState({
          error: ''
        });
        (_this$surface4 = this.surface) === null || _this$surface4 === void 0 ? void 0 : _this$surface4.retryArtwork();
      }, this.state.busy || !(p === null || p === void 0 ? void 0 : p.outcome)), ((_this$state$snapshot2 = this.state.snapshot) === null || _this$state$snapshot2 === void 0 ? void 0 : _this$state$snapshot2.uncertain) && button('重試原開卡要求', () => {
        var _this$session3;

        return (_this$session3 = this.session) === null || _this$session3 === void 0 ? void 0 : _this$session3.open();
      }, this.state.busy || (p === null || p === void 0 ? void 0 : p.status) !== 'REVEALED'), h('label', null, h('input', {
        type: 'checkbox',
        ref: e => this.reduceControl = e
      }), ' 減少動態'), this.state.error && h('p', {
        role: 'alert'
      }, this.state.error), this.state.busy && h('p', {
        role: 'status'
      }, '正在確認原卡包…'))), h('canvas', {
        ref: e => this.fxCanvas = e,
        'aria-hidden': true,
        className: 'opcards-fx'
      }));
    }

  }

  function OpCardPaymentReturn({
    onInventory
  }) {
    return h('aside', {
      className: 'opcards-return'
    }, h('strong', null, '查看我的卡包'), h('p', null, '由伺服器確認付款及卡包入庫狀態；本頁不觸發付款或補發。'), button('前往我的卡包', onInventory, typeof onInventory !== 'function'));
  }

  return {
    OpCardEntrances,
    OpCardHub,
    OpCardOpening,
    OpCardOwnedView,
    OpCardPaymentReturn
  };
}

module.exports = {
  createComponents,
  SLOGAN,
  deliveryLabel
};
